import type { ButtonHTMLAttributes, ReactNode } from "react";
import { useIdioma } from "../../i18n/IdiomaProvider";
import { normalizarTextoPtBr } from "../../utils/textoPtBr";
import styles from "./ChipSelecao.module.css";

export type TamanhoChipSelecao = "compacto" | "padrao";

export interface ChipSelecaoProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selecionado?: boolean;
  tamanho?: TamanhoChipSelecao;
  iconeInicio?: ReactNode;
  mostrarIndicadorSelecao?: boolean;
  semNegritoQuandoSelecionado?: boolean;
}

export function ChipSelecao({
  selecionado = false,
  tamanho = "compacto",
  iconeInicio,
  mostrarIndicadorSelecao = false,
  semNegritoQuandoSelecionado = false,
  className,
  children,
  type,
  ...rest
}: ChipSelecaoProps) {
  const { traduzir } = useIdioma();
  const classes = [
    styles.chip,
    styles[tamanho],
    selecionado ? styles.selecionado : "",
    semNegritoQuandoSelecionado ? styles.semNegritoQuandoSelecionado : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  const conteudo =
    typeof children === "string" || typeof children === "number"
      ? traduzir(normalizarTextoPtBr(children))
      : children;

  return (
    <button
      type={type ?? "button"}
      className={classes}
      aria-pressed={selecionado}
      {...rest}
    >
      {mostrarIndicadorSelecao && selecionado ? (
        <span className={styles.indicador} aria-hidden="true">
          <IconeCheck />
        </span>
      ) : null}
      {iconeInicio ? <span className={styles.icone}>{iconeInicio}</span> : null}
      {conteudo != null ? <span className={styles.rotulo}>{conteudo}</span> : null}
    </button>
  );
}

function IconeCheck() {
  return (
    <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path
        d="M2.5 6.2 4.8 8.5 9.5 3.8"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
